<template>
  <div id="ec-promo">
    <div class="text-content">
      <div class="try-header"> 
        <sparkle-icon class="sparkle-icon" />
        <div class="utd-text">
          <span> UpToDate </span>
          <span> ® </span>
          <span> AI </span>
        </div>
        <span class="alpha-text"> ALPHA </span>
      </div>
      <div class="sub-text"> 
        <span>
          Generative AI Conversational Experience
        </span>
        <div class="try-it-container">
          <button v-if="isAnonymousUser" class="try-it-link" @click="openLoginRegisterModal">
            <span> Try it </span>
            <span class="wk-icon-arrow-right" />
          </button>
          <a v-else
             class="try-it-link"
             :href="utdAIURL"
             rel="noopener"> 
            <span> Try it </span>
            <span class="wk-icon-arrow-right" />
          </a>
        </div>
      </div>
    </div>
    <LoginRegisterModal ref="loginRegisterModal" />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import SparkleIcon from '_acaSrc/components/shared/svg/SparkleIcon.vue';
import LoginRegisterModal from '_acaSrc/components/login/LoginRegisterModal.vue';

const store = useStore();
const isAnonymousUser = computed(() => store.getters['app/isAnonymousUser']);
const loginRegisterModal = ref(null);
const utdAIURL = computed(() => store.getters['app/utdAIURL']);

const openLoginRegisterModal = () => {
    loginRegisterModal.value.open();
};
</script>

<style scoped lang="less">
@import  '~_acaAssets/wkce/wkce-app-spacing.less';
@import '~_acaAssets/wkce/colors/wkce-app-styles.less';

#ec-promo {
  .ds1-utd-font();
  display: flex;
  padding: 16px 0 18px;
  border: 2.5px solid transparent;
  border-width: 2.5px 0;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
  transition: opacity 0.2s ease-in-out;
  background: @WKCE-BLUE-TINT5; // Old Safari version backup

  /* stylelint-disable-next-line declaration-property-value-no-unknown, color-no-hex */
  background: linear-gradient(0deg, #E6F2F9) padding-box,
              linear-gradient(
                92.17deg,
                @WKCE-GREEN-TINT1 0.38%,
                @WKCE-BLUE 60.59%,
                @WKCE-GREEN-TINT1 120.8%
              ) border-box;

  &.desktop-ec-promo {
    display: none;
  }

  .sparkle-icon {
    padding-top: 3.29px;
  }

  .text-content {
    width: 100%;
    max-width: 250px;

    .try-header {
      color: @WKCE-BLACK;
      display: flex;
      justify-content: center;
      align-items: baseline;
      gap: 2px;

      .utd-text {
        color: @WKCE-GRAY-SHADE1;
        display: inline-flex;
        font-weight: 500;
        font-size: 16px;
        font-family: "Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;;
        
        > span:nth-child(2) {
          font-size: 10px;
        }
      }

      .alpha-text {
        font-weight: 600;
        font-size: 7px;
        letter-spacing: 0.8px;
      }
    }

    .sub-text {
      margin-top: 2px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      row-gap: 13px;
      color: @WKCE-GRAY;
      font-weight: 400;
      font-size: 12px;

      > span {
        min-width: 210px;
      }

      .try-it-container {
        display: flex;
        flex-basis: fit-content;
        width: 100%;
      
        .try-it-link {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-left: auto;
          margin-right: auto;
          font-size: 10px;
          font-weight: 600;
          color: @WKCE-WHITE;
          background: @WKCE-BLUE;
          padding: 7px 41px;
          border-radius: 4px;
          border-width: 0;
          transition: background-color 0.25s ease-in-out;
          
          &:hover {
            text-decoration: none;
            background: @WKCE-BLUE-SHADE2;
          }

          .wk-icon-arrow-right {
            font-size: 12px;
            margin: 0;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 768px) {
  .isDesktop:not(.isTablet) #ec-promo {
    justify-content: normal;

    &.mobile-web-ec-promo {
      display: none;
    }

    &.desktop-ec-promo {
      display: flex;
      padding: 10px 12px 10px 8px;
      box-shadow: inset 0 4px 4px 0 #00000040; /* stylelint-disable-line color-no-hex */
      border: 2.5px solid transparent;
      border-top: none;
      border-radius: 0 0 10px 10px;
      max-width: 295px;
      margin: -1px 1px 0 64px;
      width: 100%;
      
      .text-content {
        max-width: 100%;
        
        .try-header {
          justify-content: left;
          .utd-text {
            font-size: 14px;
          }
        }

        .sub-text {
          .ds1-ml-2();
          align-items: center;
          justify-content: space-between;
          font-size: 11px;
          
          .try-it-container {
            flex-grow: 1;
            max-width: 210px;
    
            .try-it-link {
              margin-right: 0;
              padding: 2px 8px;
              gap: 6px;
            }
          }
        }
      }
    }
  }
}
</style>